import WebpackerReact from 'webpacker-react';
import Turbolinks from 'turbolinks'

import Hello from '../components/hello';

Turbolinks.start()

WebpackerReact.setup({
  Hello
})